/**
 * The web app's sign-up questions (rudder-webapp `authV2/esignup/completeAccountFormFields.tsx`), which Lookout's
 * own sign-up also asks (ACT2-871). Fixed lists, so an answer reaches analytics as a category, never as free text.
 * Dependency-free: the SPA imports it through `@server/signup-answers`.
 */
export const SIGNUP_ROLES = [
  'Engineering',
  'Marketing',
  'Founder/Executive',
  'Product',
  'Analytics',
  'Something else',
] as const;
export type SignupRole = (typeof SIGNUP_ROLES)[number];

export const SIGNUP_HEARD_ABOUT_SOURCES = [
  'Online search',
  'Podcast',
  'Social media (LinkedIn, YouTube, Twitter)',
  'Word of mouth / referral',
  'Online ads',
  'Event',
  'White Paper',
  'Other',
] as const;
export type SignupHeardAboutSource = (typeof SIGNUP_HEARD_ABOUT_SOURCES)[number];

/** Answers to the sign-up questions that Lookout sends on its sign-up analytics event. */
export interface SignupAnswers {
  role: SignupRole;
  heardAboutSource?: SignupHeardAboutSource;
}

/** config-backend's free-tier regions. The region applies to the RudderStack workspace only, not to Lookout. */
export const SIGNUP_REGIONS = ['US', 'EU'] as const;
export type SignupRegion = (typeof SIGNUP_REGIONS)[number];
